<input type="hidden" name="authenticity_token" value={csrf_token} />

<script lang="ts">
  import { onMount } from 'svelte'

  let csrf_token

  onMount(async () => {
    const el = document.querySelector("meta[name='csrf-token']") as HTMLMetaElement
    if (el) {
      csrf_token = el.content
    }
  })
</script>
